import React from 'react';
import { useParams } from 'react-router-dom';
import { useRequest } from 'hooks';

import Show from 'components/Show';
import Editor from 'components/Editor';
import { Files } from 'components/Misc/Form';
import { Title } from 'components/Misc/Typography';

import { useExamStudentStore } from 'store/exam/useExamStudentStore';

const Question = ({ idx, noTitle, question }) => {
	// Store current take id
	const { id } = useParams();

	// Store requests
	const [, upload] = useRequest('post', `answers/${id}`, true);
	const [, remove] = useRequest('delete', `answers/${id}`, true);

	// Use exam's student store
	const [slug, onFileAdd, onFileRemove] = useExamStudentStore(state => [
		state.exam.slug,
		state.onFileAdd,
		state.onFileRemove
	]);

	// Handle upload files on change
	const onUploadAnswers = async ({ files }) => {
		// Create formdata instance
		const data = new FormData();

		// Append all selected files
		Array.from(files).forEach(file => data.append('files', file));

		// Upload user's files
		const [success] = await upload(data, {
			action: 'upload',
			answerId: question.id
		});

		// Update take's file state
		if (success) onFileAdd(question.id, success.files);
	};

	// Handle file removal on click
	const onRemoveAnswers = async (fileId) => {
		// Remove user's file
		const [success] = await remove({
			fileId
		}, {
			answerId: question.id
		});

		// Update take's file state
		if (success) onFileRemove(question.id, fileId);
	};

	return (
		<div className="flex flex-col gap-1">
			{/* Show title only if more than one question */}
			<Show if={!noTitle}>
				<Title title={`${idx + 1}. jautājums`} />
			</Show>

			{/* Question's description */}
			<Editor
				readOnly
				path="exams"
				folder={slug}
				value={question?.content}
			/>

			{/* Question's answer upload */}
			<Files
				label="Augšupielādētie faili"
				name="files"
				uploaded={question.files}
				onChange={onUploadAnswers}
				onRemove={onRemoveAnswers}
			/>
		</div>
	);
};

export default Question;